import Profil from "./components/Common/Pages/Profil";
import APIKey from "./components/Admin/APIKEY/APIKey";
import UserManagement from "./components/UserManagement/UserManagement";
import DashboardRepport from "./components/Reports/DashboardReports/DashboardReport";
import WriteReportView from "./components/Reports/EditReports/WriteReportView";
import ComplainForm from "./components/Casserole/Plaintes/ComplainForm";
import AccessRightManagement from "./components/Admin/AccessRight/AccessRightManagement";
import ArticleView from "./components/Articles/DisplayArticles/ArticleView";
import MemoHebdo from "./components/MemoHebdo/Pages/MemoHebdo.jsx";
import CreateArticle from "./components/MemoHebdo/Pages/CreateArticle";
import EditArticle from "./components/MemoHebdo/Pages/EditArticle";
import ArticleDetails from "./components/MemoHebdo/Pages/ArticleDetails";
import WriteArticleView from "./components/Articles/EditArticles/WriteArticleView";
import SpecialMessageEditor from "./components/Casserole/SpecialMessage/SpecialMessageEditor";
import FranchiseeSurvey from "./components/Survey/FranchiseeSurvey";
import InternalEmployeeSurvey from "./components/Survey/InternalEmployeeSurvey";
/*import RecipesView from "./components/Recipes/RecipesView";*/
import RecipeDetails from "./components/Recettes/RecipeDetails";
import AddRecipe from "./components/Recettes/AddRecipe";
import EditRecipe from "./components/Recettes/EditRecipe";
import CategoryDetail from "./components/Recettes/CategoryDetail";
import Recipes from "./components/Recettes/Category";
import BottinTelephonique from "./components/BotinTelephonique/BottinTelephonique";
import ComplaintAdmin from "./components/Casserole/Plaintes/Admin/ComplaintAdmin";
import CompanyView from "./components/CompaniesManagement/CompanyView";
import JobManagement from "./components/Admin/Jobs/JobManagement";
import LocationView from "./components/Emplacement/LocationView";
import InternalUserManagementView from "./components/Admin/InternalUserManagement/InternalUserManagementView";
import DashboardView from "./components/Dashboard/Franchises/DashboardView";
import VideoView from "./components/VideoSection/VideoView";
import Requests from "./components/Requests/Requests";
import EmployeeManagement from "./components/UserManagement/EmployeeManagement.jsx";
import TemporaryClosures from "./components/Admin/TemporaryClosures/pages/TemporaryClosures.jsx";
import CompetitionSurvey from "./components/Admin/CompetitionSurvey/pages/CompetitionSurvey.jsx";

const AppRoutes = [
  {
    index: true,
    element: <ArticleView />,
    requiredRole: null,
  },
  {
    path: "/Articles",
    element: <ArticleView />,
    requiredRole: null,
  },
  {
    path: "/WriteArticle",
    element: <WriteArticleView />,
    requiredRole: ["AdminTI", "ArticleWriter", "ArticleAdmin"],
  },
  {
    path: "/ArticleManagement",
    element: <MemoHebdo />,
    requiredRole: ["AdminTI", "ArticleWriter", "ArticleAdmin"],
  },
  {
    path: "/ArticleManagement/Create",
    element: <CreateArticle />,
    requiredRole: ["AdminTI", "ArticleWriter", "ArticleAdmin"],
  },
  {
    path: "/ArticleManagement/Edit/:id",
    element: <EditArticle />,
    requiredRole: ["AdminTI", "ArticleWriter", "ArticleAdmin"],
  },
  {
    path: "/ArticleManagement/Details/:id",
    element: <ArticleDetails />,
    requiredRole: ["AdminTI", "ArticleWriter", "ArticleAdmin"],
  },
  {
    path: "/Profil",
    element: <Profil />,
    requiredRole: null,
  },
  {
    path: "/SpecialMessage",
    element: <SpecialMessageEditor />,
    requiredRole: ["AdminTI", "CasseroleAdmin"],
  },
  {
    path: "/APIKey",
    element: <APIKey />,
    requiredRole: ["AdminTI"],
  },
  {
    path: "/TemporaryClosures",
    element: <TemporaryClosures />,
    requiredRole: ["AdminTI", "LocationAdmin", "Coachs"],
  },
  {
    path: "/CompetitionSurvey",
    element: <CompetitionSurvey />,
    requiredRole: ["AdminTI"],
  },
  {
    path: "/UserManagement",
    element: <UserManagement />,
    requiredRole: ["AdminTI", "Franchisees", "Manager", "InternalEmployee"],
  },
  {
    path: "/InternalUserManagement",
    element: <InternalUserManagementView />,
    requiredRole: ["AdminTI", "InternalUsermanagers"],
  },
  {
    path: "/CompanyManagement",
    element: <CompanyView />,
    requiredRole: ["AdminTI", "CompanyAdmin", "CompanyReader"],
  },
  {
    path: "/JobManagement",
    element: <JobManagement />,
    requiredRole: [
      "AdminTI",
      "Manager",
      "Franchisees",
      "KitchenManage",
      "ServiceManager",
      "InternalEmployee",
      "LocationAdmin",
    ],
  },
  {
    path: "/Location",
    element: <LocationView />,
    requiredRole: ["AdminTI", "LocationAdmin", "LocationReader"],
  },
  {
    path: "/Reports",
    element: <WriteReportView />,
    requiredRole: ["AdminTI", "ReportAdmin", "ReportWriter"],
  },
  {
    path: "/DashboardReport",
    element: <DashboardRepport />,
    requiredRole: ["AdminTI", "ReportAdmin", "ReportWriter"],
  },
  {
    path: "/Requests",
    element: <Requests />,
    requiredRole: ["AdminTI"],
  },
  {
    path: "/EmployeeManagement",
    element: <EmployeeManagement />,
    requiredRole: [
      "AdminTI",
      "Manager",
      "Franchisees",
      "KitchenManager",
      "InternalEmployee",
      "ServiceManager",
      "LocationAdmin",
    ],
  },
  {
    path: "/CompetitionSurveyFranchisees",
    element: <FranchiseeSurvey />,
    requiredRole: ["AdminTI", "Franchisees"],
  },
  {
    path: "/CompetitionSurveyInternalEmployees",
    element: <InternalEmployeeSurvey />,
    requiredRole: ["AdminTI", "InternalEmployee"],
  },
  {
    path: "/Complaint",
    element: <ComplainForm />,
    requiredRole: null,
  },
  {
    path: "/ComplaintAdmin",
    element: <ComplaintAdmin />,
    requiredRole: ["AdminTI", "CasseroleAdmin"],
  },
  {
    path: "/AccessRight",
    element: <AccessRightManagement />,
    requiredRole: ["AdminTI"],
  },
  /*{
    path: "/Recipes",
    element: <RecipesView />,
    requiredRole: null,
  },*/
  {
    path: "/Recipes",
    element: <Recipes />,
    requiredRole: null,
  },
  {
    path: "/Category/:id",
    element: <CategoryDetail />,
    requiredRole: null,
  },
  {
    path: "/Recipe/Add/:categoryId",
    element: <AddRecipe />,
    requiredRole: ["AdminTI", "RecipeAdmin"],
  },
  {
    path: "/Recipe/Edit/:id",
    element: <EditRecipe />,
    requiredRole: ["AdminTI", "RecipeAdmin"],
  },
  {
    path: "/Recipe/:id",
    element: <RecipeDetails />,
    requiredRole: null,
  },
  {
    path: "/Videos",
    element: <VideoView />,
    requiredRole: ["AdminTI"],
  },
  {
    path: "/Bottin",
    element: <BottinTelephonique />,
    requiredRole: null,
  },
  {
    path: "/Dashboard",
    element: <DashboardView />,
    requiredRole: ["AdminTI"],
  },
];

export default AppRoutes;
